import axios from "@/modules/axios";
import router from "@/modules/router";

export default {
	namespaced: true,

	state: {
		data: null,
		auth: JSON.parse(localStorage.getItem("auth"))
	},

	mutations: {
		data(state, {data}) {
			state.data = data;
		},
		authSet(state, {data}) {
			state.auth = data;
			localStorage.setItem("auth", JSON.stringify(data));
		},
		authDelete(state) {
			state.auth = null;
			localStorage.removeItem("auth");
		}
	},

	actions: {
		async login({commit, dispatch}, {form, route}) {
			const {data} = await axios.post("admin/login", form, {custom: true});
			commit("authSet", {data});
			await dispatch("data");
			router.push(route);
		},

		async logout({commit}, {post} = {}) {
			try {
				if (post) await axios.post("admin/logout");
			} catch (err) {
				// ignore error
			} finally {
				commit("authDelete");
				router.push({name: "login", params: {route: {path: window.location.pathname}}});
			}
		},

		async forgotPassword(ctx, {email}) {
			return await axios.post("admin/password/email", {email}, {custom: true});
		},

		async data({commit, getters}) {
			if (getters.auth) {
				const {data} = await axios.get("client/account");
				commit("data", data);
				return getters.data;
			}
		}
	},

	getters: {
		auth(state) {
			return state.auth;
		},
		data(state) {
			return state.data;
		},
		cart(state, getters) {
			return getters.data ? state.data.active_cart : null;
		}
	}
};
